(function (root) {
  'use strict';
  if (root.WallForgeSizeDisplay) return;
  const key = 'wallforge-size-unit';
  let unit = 'in';
  function read() {
    try { unit = root.localStorage.getItem(key) === 'cm' ? 'cm' : 'in'; } catch (_) { /* Keep the session preference when storage is unavailable. */ }
    return unit;
  }
  function label(value, selectedUnit = unit, templates = {}) {
    // Accept canonical inch dimensions only; unknown catalog labels remain intact.
    const match = String(value || '').match(/^\s*(\d+(?:\.\d+)?)\s*[x\u00d7]\s*(\d+(?:\.\d+)?)\s*(?:in(?:ches)?|["\u2033])?\s*$/i);
    if (!match || Number(match[1]) <= 0 || Number(match[2]) <= 0) return value || '';
    const cm = selectedUnit === 'cm';
    const dimensions = match.slice(1).map(n => cm ? Number((Number(n) * 2.54).toFixed(1)) : Number(n));
    const template = cm ? templates.cm || '\u2248 {width} \u00d7 {height} cm' : templates.in || '{width} \u00d7 {height} in';
    return template.replace('{width}', dimensions[0]).replace('{height}', dimensions[1]);
  }
  function announce() {
    root.dispatchEvent(new CustomEvent('wallforge:size-unit', { detail: { unit } }));
  }
  function setUnit(value) {
    if (!['in', 'cm'].includes(value)) return;
    unit = value;
    try { root.localStorage.setItem(key, unit); } catch (_) { /* Labels still work for this session. */ }
    announce();
  }
  function refresh() {
    const previous = unit;
    read();
    if (unit !== previous) announce();
  }
  read();
  root.WallForgeSizeDisplay = { label, getUnit: () => unit, setUnit };
  root.addEventListener('storage', event => { if (event.key === key || event.key === null) refresh(); });
  root.addEventListener('pageshow', refresh);
})(window);
